import React from 'react';
import Navbar from '../components/LandingPage-main/Navbar';
import Footer from '../components/PlumPlusDash/Footer';

const LegalMentions = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="mt-[72px] flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="bg-white rounded-lg shadow-sm p-6 sm:p-10">
            <h1 className="text-3xl font-semibold mb-6 text-gray-800 border-b pb-3">
              Mentions Légales
            </h1>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <div className="bg-blue-50 p-5 rounded-md">
                <p className="mb-1"><span className="font-medium">Nom du site :</span> clicdroit.info</p>
                <p className="mb-1"><span className="font-medium">Propriétaire :</span> [Votre Nom ou Dénomination Sociale]</p>
                <p><span className="font-medium">Hébergeur :</span> [Nom de l'hébergeur, ex. OVH / AWS, etc.]</p>
              </div>
              
              <section aria-labelledby="editorial-responsibility">
                <h2 id="editorial-responsibility" className="text-xl font-medium text-gray-800 mb-3">
                  Responsabilité éditoriale
                </h2>
                <p className="text-base sm:text-lg">
                  Les informations diffusées sur clicdroit.info sont fournies à titre informatif. 
                  Malgré tout le soin apporté à leur exactitude, des erreurs peuvent subsister. 
                  L'utilisation des informations et contenus disponibles sur l'ensemble du site 
                  ne saurait en aucun cas engager la responsabilité de clicdroit.info.
                </p>
              </section>
              
              <section aria-labelledby="copyright">
                <h2 id="copyright" className="text-xl font-medium text-gray-800 mb-3">
                  Droits d'auteur
                </h2>
                <p className="text-base sm:text-lg">
                  Toute reproduction, représentation ou diffusion, en tout ou partie, du contenu 
                  de ce site sur un quelconque support ou par tout procédé, sans l'autorisation 
                  écrite de [Propriétaire], est strictement interdite.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalMentions;
